"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var userSlice_1 = require("../../../../../../features/user/userSlice");
var AmenityItem_1 = __importDefault(require("../../../../AmenityList/AmenityItem"));
var styles_module_scss_1 = __importDefault(require("../../../../AmenityList/styles.module.scss"));
var DeveloperEstablishmentInfo = function (_a) {
    var dateOfEstablishment = _a.dateOfEstablishment, developerProjects = _a.developerProjects;
    var t = react_i18next_1.useTranslation('common').t;
    var user = react_redux_1.useSelector(userSlice_1.useSelectUser);
    if (!user) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.developer_establishment_info },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_amenity_list },
            dateOfEstablishment && (react_1.default.createElement(AmenityItem_1.default, { data: [dateOfEstablishment], icon: 'icon-calendar', title: t('POST_PREVIEW.DEVELOPER_INFO_SECTION.DATE_OF_ESTABLISHMENT'), makeTranslation: false })),
            !!(developerProjects === null || developerProjects === void 0 ? void 0 : developerProjects.length) && (react_1.default.createElement(AmenityItem_1.default, { data: developerProjects.map(function (item) { return item.name; }), icon: 'cm-icon icon-ic-all-apts', title: t('POST_PREVIEW.DEVELOPER_INFO_SECTION.DONE_PROJECTS'), makeTranslation: false })))));
};
exports.default = react_1.memo(DeveloperEstablishmentInfo);
